(($) => {
    $(document).on('ready', init);

    function init() {
        bind();
    }

    function bind() {
        $('html').on('bb-lumeris:lum-interior-page-header:init', moduleInit);
    }

    function moduleInit(event, data) {
        if (!event || !data) {
            return false;
        }

        const $module = $(`.fl-node-${data.node}`);
        
        $module.find('.breadcrumbs-container a').on('click', (event) => {
            document.dispatchEvent(new CustomEvent('gform-recaptcha:doAction', { detail: { action: 'breadcrumb_link_click' }}));
        });

        $module.find('.content-overlay a').on('click', (event) => {
            document.dispatchEvent(new CustomEvent('gform-recaptcha:doAction', { detail: { action: 'link_click' }}));
        });

        $module.find('.content-overlay form').on('submit', (event) => {
            document.dispatchEvent(new CustomEvent('gform-recaptcha:doAction', { detail: { action: 'submit' }}));
        });

        $module.find('.content-overlay input, .content-overlay textarea, .content-overlay select').on('focus', (event) => {
            document.dispatchEvent(new CustomEvent('gform-recaptcha:doAction', { detail: { action: 'focus' }}));
        });

        $module.find('.content-overlay button, .content-overlay input[type="submit"], .content-overlay input[type="button"]').on('click', (event) => {
            document.dispatchEvent(new CustomEvent('gform-recaptcha:doAction', { detail: { action: 'button_click' }}));
        });
    }
})(jQuery);